<template>
  <div v-if="current" class="laureatContainer">
    <Laureat v-for="(item, index) in randOrd" :item="item" :key="item.title + index" :index="index"/>
  </div>
</template>

<script>
import Laureat from '@/components/Laureat'
import setLaureat from '@/components/setLaureat'

export default {
  mixins: [setLaureat],

  components: {
    Laureat
  },

  mounted () {
    this.$root.$emit('scrollAfterEnter')

    let backState = {
      page: 'current'
    }

    this.$store.commit('editState', { state: 'backState', data: backState })
  },

  watch: {
    randOrd (val) {
      this.$store.commit('editState', { state: 'currentLoop', data: this.randOrd })
    }
  },

  computed: {
    current () {
      return this.$store.getters.current
    },

    randOrd () {
      let current = this.current
      if (current) {
        // Set size and randomize project order
        let j
        let x
        let i

        for (i = 0; i < current.length; i++) {
          x = current[i]
          j = Math.floor(Math.random() * (i + 1))
          current[i] = current[j]
          current[j] = x
        }

        current.forEach((item, index) => {
          this.setLaureat(item, index, current)
        })

        let nArr = []
        current.forEach((item, index) => {
          if (item.col === 2) {
            nArr.splice(index - 1, 0, item)
          } else {
            nArr.push(item)
          }
        })

        return nArr
      } else {
        return null
      }
    }
  }
}
</script>
